/**
 * Top Workers card - profile cards with image area, name, rating, revenue.
 * Design: reference worker profile cards with "View All Staff" link at bottom.
 */
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../components/AdminLayout';
import WorkerProfileCard from './WorkerProfileCard';

export default function TopWorkersCard({ workers = [], viewAllHref, onViewAll, loading }) {
  const { t } = useTranslation();
  const { T } = useTheme();

  const list = (workers || []).slice(0, 4);

  return (
    <div
      style={{
        background: '#ffffff',
        border: '1px solid #e2e8f0',
        borderRadius: 12,
        padding: '1.25rem 1.5rem',
        boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
      }}
    >
      <h2
        style={{
          fontFamily: "'DM Sans', sans-serif",
          fontSize: '1.125rem',
          fontWeight: 700,
          color: '#1e293b',
          marginBottom: '1rem',
        }}
      >
        {t('dashboard.topWorkers') || 'Top Workers'}
      </h2>

      {loading ? (
        <div style={{ color: T.muted, fontSize: '0.9rem' }}>...</div>
      ) : list.length === 0 ? (
        <div style={{ color: T.muted, fontSize: '0.9rem' }}>{t('dashboard.noWorkers') || 'No workers yet.'}</div>
      ) : (
        <>
          <div style={{ display: 'flex', gap: '1rem', overflowX: 'auto', paddingBottom: '0.5rem', flexWrap: 'wrap' }}>
            {list.map((w, idx) => (
              <WorkerProfileCard key={w.artist_id || idx} worker={w} rank={idx + 1} />
            ))}
          </div>
          <div
            style={{
              marginTop: '1.25rem',
              paddingTop: '1rem',
              borderTop: `1px solid ${T.border}`,
              textAlign: 'center',
            }}
          >
            {viewAllHref ? (
              <Link
                to={viewAllHref}
                style={{
                  fontSize: '0.875rem',
                  color: T.muted,
                  textDecoration: 'none',
                  fontWeight: 500,
                }}
              >
                {t('dashboard.viewAllStaff') || 'View All Staff'}
              </Link>
            ) : onViewAll ? (
              <button
                type="button"
                onClick={onViewAll}
                style={{
                  fontSize: '0.875rem',
                  color: T.muted,
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  fontWeight: 500,
                  padding: 0,
                }}
              >
                {t('dashboard.viewAllStaff') || 'View All Staff'}
              </button>
            ) : null}
          </div>
        </>
      )}
    </div>
  );
}
